import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M23.25 7.311 12.53 18.03a.75.75 0 0 1-1.06 0L.75 7.311"
    }, null, -1)
  ]));
}
const arrowChevronDown = { render };
export {
  arrowChevronDown as default,
  render
};
//# sourceMappingURL=arrow-chevron-down.svg.js.map
